import FilterDataActions from "@redux/feature/Common/action/FilterDataActions";
export default (function () {
    return {
        filter: {
            filterDataActions: new FilterDataActions(),
        },
    };
});
